// extracted by mini-css-extract-plugin
export default {"component":"NewEmployeesModal_component__5oRB8","modalContainer":"NewEmployeesModal_modalContainer__NpX-2","input":"NewEmployeesModal_input__YT9Ul"};